const KEY_ACCESS  = 'auth.access';
const KEY_REFRESH = 'auth.refresh';
const KEY_USER    = 'auth.user';

export const auth = {
  get access()  { return localStorage.getItem(KEY_ACCESS); },
  get refresh() { return localStorage.getItem(KEY_REFRESH); },
  get user()    {
    try { return JSON.parse(localStorage.getItem(KEY_USER) || 'null'); }
    catch { return null; }
  },

  set(tokens) {
    localStorage.setItem(KEY_ACCESS,  tokens.access_token);
    localStorage.setItem(KEY_REFRESH, tokens.refresh_token);
    localStorage.setItem(KEY_USER,    JSON.stringify(tokens.user || {}));
  },

  setAccess(token) {
    if (token) localStorage.setItem(KEY_ACCESS, token);
  },

  clear() {
    localStorage.removeItem(KEY_ACCESS);
    localStorage.removeItem(KEY_REFRESH);
    localStorage.removeItem(KEY_USER);
  },

  isAuthed() { return !!this.access; },
};
